<div class="cardLayout">
  <ion-row>
    <ion-col size="4">
      <div class="formLabelBoldfs18 mb-5">{{popupName}}</div>
    </ion-col>
      <ion-col size="8" class="text-right">
        <img *ngIf="popupName == 'Access' && loggedInUserRole!='Admin'" class="mr-10 cp imgedit" (click)="onClickEdit()" src="././assets/icon/edit.png">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
  </ion-row>
  <ion-row *ngIf="popupName == 'Modules List'">
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" *ngFor="let item of listData">
      <span class="formLabelRegularfs16">{{item.moduleName}}</span>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="popupName == 'Access'">
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="formLabelRegularfs16 mb-5">Location</div>
      <div class="formLabelBoldfs16">
        <label *ngFor="let item of locationList;let isLast=last">{{item}} {{isLast ? '' : ',&nbsp;'}}</label>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="formLabelRegularfs16 mb-5">Band</div>
      <div class="formLabelBoldfs16">
        <label *ngFor="let item of bandList;let isLast=last">{{item}} {{isLast ? '' : ',&nbsp;'}}</label>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="formLabelRegularfs16 mb-5">Department</div>
      <div class="formLabelBoldfs16">
        <label *ngFor="let item of departmentList;let isLast=last">{{item}} {{isLast ? '' : ',&nbsp;'}}</label>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="formLabelRegularfs16 mb-5">Designation</div>
      <div class="formLabelBoldfs16">
        <label *ngFor="let item of designationList;let isLast=last">{{item}} {{isLast ? '' : ',&nbsp;'}}</label>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="formLabelRegularfs16 mb-5">Employee</div>
      <div class="formLabelBoldfs16">
        <label *ngFor="let item of employeeList;let isLast=last">{{item.firstName}} {{item.lastName}} {{isLast ? '' : ',&nbsp;'}}</label>
      </div>
    </ion-col>
  </ion-row>
</div>